export default __webpack_public_path__ + "1737731e3a77038711d698ab165f44af.svg";